<template>
  <div class="menu-frame">
    <el-main>
      <!-- 패널 -->
      <!-- <el-card shadow="never" v-loading="contents_loading"> -->
      <el-card shadow="never">
        <div slot="header">
          <i class="icon iconfont" :class="menuIcon"></i>
          <span>{{ menuNmLan }}</span>
        </div>
        <div ref="content" class="content">
          <slot></slot>
        </div>
      </el-card>
    </el-main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ORDER_REFUND_PENDING_PATH, ORDER_REFUND_TEXT } from '@/utils/orderRefund'

let rafId = null

export default {
  name: 'MenuFrame',

  data() {
    return {
      // mainMenu api 외 지정된 페이지 정보
      presetMenuList: [
        {
          url: '/v/business/user/cust',
          menuIcon: 'icon-people',
          menuNm: this.$t('계정 정보 수정'),
          menuNmLan: this.$t('계정 정보 수정'),
          useYn: 'Y',
        },
        {
          url: '/v/business/user/store',
          menuIcon: 'icon-people',
          menuNm: this.$t('계정 정보 수정'),
          menuNmLan: this.$t('계정 정보 수정'),
          useYn: 'Y',
        },
        {
          url: '/v/system/account/info',
          menuIcon: 'icon-people',
          menuNm: this.$t('계정 정보 수정'),
          menuNmLan: this.$t('계정 정보 수정'),
          useYn: 'Y',
        },
        // 내부 운영자용 환불 실패 목록 — 메뉴 행이 생기면 그 행(`currentMenu`)이 먼저다
        {
          url: ORDER_REFUND_PENDING_PATH,
          menuIcon: 'icon-order',
          menuNm: this.$t(ORDER_REFUND_TEXT.pendingListTitle),
          menuNmLan: this.$t(ORDER_REFUND_TEXT.pendingListTitle),
          useYn: 'Y',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      currentMenu: 'menu/currentMenu',
      contentsLoading: 'ui/contentsLoading',
    }),
    persetMenuInfo() {
      return this.presetMenuList.find((menu) => menu.url === this.$route.path)
    },
    menuIcon() {
      return this.currentMenu?.menuIcon ?? this.persetMenuInfo?.menuIcon
    },
    menuNmLan() {
      return this.currentMenu?.menuNmLan ?? this.persetMenuInfo?.menuNmLan
    },
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.onResize()
      }
    },
    contentsLoading(val) {
      this.onResize()
    },
  },
  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
    this.$root.$on('resize', this.onResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    this.$root.$off('resize', this.onResize)
  },
  methods: {
    onResize() {
      const fn = () => {
        const wrapper = this.$refs.content
        const el = wrapper?.querySelector('.contain')

        if (!el) return

        const siblings = [el.querySelector('.buttons'), el.querySelector('.search_form')].filter((x) => !!x)
        const siblingsHeight = siblings.reduce((acc, sibling) => {
          if (sibling) {
            acc += sibling.offsetHeight
            acc += parseInt(getComputedStyle(sibling).marginTop) || 0
            acc += parseInt(getComputedStyle(sibling).marginBottom) || 0
          }
          return acc
        }, 0)

        const screenHeight = document.documentElement.clientHeight
        const adjust = this.$device.mobile ? 150 : 200 // menuframe 반응형 사이즈 이하일 경우 조정
        let height = screenHeight - siblingsHeight - adjust

        if (this.$device.tablet) {
          height = Math.max(height, 350)
        }

        this.$store.commit('ui/setTableHeight', height)
        this.$store.commit('ui/setInputHeight', height)
      }

      if (rafId) {
        cancelAnimationFrame(rafId)
        rafId = null
      }

      rafId = requestAnimationFrame(fn)
    },
  },
}
</script>

<style scoped>
.icon {
  margin-right: 5px;
  color: var(--color-primary);
}

.menu-frame {
  /* width: 100%; */
  flex-grow: 1;
  min-width: 1px;
}
.menu-frame::v-deep .el-card__body {
  min-width: 100%;
  height: calc(100% - 53px);
}

.el-main,
.el-card {
  /* height: 100%; */
}

.menu-frame::v-deep .el-card__body .contain {
  /* position: relative;
  height: 100%; */
}

.content {
  /* height: 100%; */
}

@media (max-width: 768px) {
  .menu-frame::v-deep .el-card {
    border: none;
  }
  .menu-frame::v-deep .el-card__header {
    padding-left: 0;
    padding-right: 0;

    border: none;
  }
  .menu-frame::v-deep .el-main {
    padding: 10px;
  }
  .menu-frame::v-deep .el-main .el-card__body {
    padding: 10px;
  }
}
</style>
